import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface UserMaterialUpdateAgentUserMaterialFolderResponse {
  message: string;
};


class UserMaterialUpdateAgentUserMaterialFolderData {
  @IsString("Folder name must be a string")
  message: string;
}

const transformAndValidateData = (
  response: UserMaterialUpdateAgentUserMaterialFolderResponse
): UserMaterialUpdateAgentUserMaterialFolderData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserMaterialUpdateAgentUserMaterialFolderData);
  } catch (error) {
    console.error("User material update agent user material folder data validation failed:", error.message);
    throw error;
  }
};

/** 修改智能体指定素材类型的文件夹列表 */
export const userMaterialUpdateAgentUserMaterialFolder = async ({
  agentId,
  folderIds,
  type
}: {
  agentId: string,
  folderIds: number[],
  type: string;
}) => {
  const typeMap = { video: 1, podcast: 2, moments: 3, post: 4, article: 5 } as const;

  const res = await api.post<UserMaterialUpdateAgentUserMaterialFolderResponse>('/user_material/user_agent_update_folder', {
    agent_id: agentId,
    folder_ids: folderIds,
    type: typeMap[type],
  });
  const data = transformAndValidateData(res.data);
  return data;
}